import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class Scroll {
    constructor() {
        this.init();
    }

    init() {
        // スクロールトリガーの設定
        this.setScrollTrigger();

        // スムーズスクロールのイベントを追加
        this.addSmoothScroll();
    }

    setScrollTrigger() {
        const $triggerArray = [...document.querySelectorAll('.js-scrollreveal')];

        $triggerArray.forEach(($trigger) => {
            ScrollTrigger.create({
                trigger: $trigger,
                start: 'top 75%',
                //markers: true,
                onEnter: () => $trigger.classList.add('-reveal'),
            });
        });
    }

    addSmoothScroll() {
        const $triggerArray = [...document.querySelectorAll('.js-smoothscroll')];

        $triggerArray.forEach(($trigger) => {
            $trigger.addEventListener('click', (e) => this.setSmoothScroll(e));
        });
    }

    setSmoothScroll(e) {
        e.preventDefault();

        const y = e.currentTarget.hash || 0;
        const scrollTo = { y: y };

        gsap.to(window, { duration: 0.8, scrollTo: scrollTo, ease: 'expo.inOut' });
    }
}
